export enum ValidationBannerEnum {
  Warning = 'WARNING',
  Error = 'ERROR',
}
